module.exports = __webpack_public_path__ + "img/重庆酉水河国家湿地公园@2x.04486a04.png";